export default __webpack_public_path__ + "static/after-9966f644455551566831f5b2c40486ec.png";